import Banner from 'components/desktop/detail-broker/banner';
import CardList from 'components/desktop/detail-broker/card-list';
import Information from 'components/desktop/detail-broker/information';
import Footer from 'components/desktop/shared/footer';
import Header2 from 'components/desktop/shared/header2';
import { Fragment } from 'react';

const DetailBroker = () => (
  <Fragment>
    <Header2 />
    <main className='flex min-h-[1000px] min-w-[1052px] flex-col'>
      <div className='my-[28px] flex flex-col space-y-[28px]'>
        <div className='relative flex flex-col'>
          <Banner />
          <Information />
          <CardList />
        </div>
      </div>
    </main>
    <Footer />
  </Fragment>
);

export default DetailBroker;
